module.exports = __webpack_public_path__ + "static/media/subject_page_bg.4c7b72b0.jpg";